export default __webpack_public_path__ + "static/media/email.844106aa.svg";